// Translations for the dental practice website
export const translations = {
  de: {
    // Navigation
    nav: {
      contact: "Kontakt",
      treatments: "Behandlungsfelder",
      team: "Team",
      directions: "Anfahrt",
      jobs: "Jobs",
      call: "Anrufen",
      bookNow: "Direkt zum Termin"
    },
    // Hero Section
    hero: {
      welcome: "Willkommen bei Ihrem Zahnarzt in Dachau",
      title1: "",
      title2: "Ihr Lächeln in besten Händen",
      description: "In unserer Zahnarztpraxis Muresan-Richter in Dachau steht Ihre Zahngesundheit im Mittelpunkt. Besonders wichtig ist uns der Erhalt Ihrer natürlichen Zähne – denn gesunde Zähne bedeuten Lebensqualität. Wir nehmen uns bewusst Zeit für Sie, hören Ihnen aufmerksam zu und gehen individuell auf Ihre Wünsche und Bedürfnisse ein. Gemeinsam mit Ihnen finden wir die beste Behandlungslösung – verständlich erklärt, transparent und auf Augenhöhe. Unser Ziel ist es, dass Sie sich bei uns gut aufgehoben fühlen und mit einem guten Gefühl nach Hause gehen.",
      services: "Unsere Leistungen",
      saveContact: "Kontakt speichern",
      address: "Adresse",
      phone: "Telefon",
      openingHours: "Öffnungszeiten"
    },
    // About Section
    about: {
      title: "Ihre Zahnarztpraxis in Dachau – Kompetenz trifft Menschlichkeit",
      text1: "Herzlich willkommen in der Zahnarztpraxis Muresan-Richter. Als Ihr <strong>Zahnarzt in Dachau</strong> ist es unser Ziel, Ihre Zahngesundheit langfristig zu bewahren und Ihnen ein strahlendes Lächeln zu schenken. In unseren modernen Praxisräumen in Dachau-Ost bieten wir Ihnen das gesamte Spektrum der zeitgemäßen Zahnheilkunde – von der professionellen Zahnreinigung (PZR) und Prophylaxe über hochwertigen Zahnersatz bis hin zur ästhetischen Zahnmedizin.",
      text2: "Besonders wichtig ist uns eine angstfreie Atmosphäre: Wir nehmen uns Zeit für eine ausführliche Beratung und setzen auf besonders schonende Behandlungsmethoden. Dank unserer zentralen Lage in der Stresemannstraße sind wir für Patienten aus dem gesamten Landkreis Dachau sowie aus Karlsfeld schnell und bequem erreichbar. Wir freuen uns darauf, Sie persönlich kennenzulernen!",
      callBtn: "Anrufen",
      bookBtn: "Jetzt Termin buchen"
    },
    // Treatments Section
    treatments: {
      subtitle: "Unsere Leistungen in Dachau",
      title: "Behandlungsfelder",
      hint: "Anklicken für weitere Details",
      learnMore: "Mehr erfahren",
      ourServices: "Unsere Leistungen:",
      bookAppointment: "Jetzt Termin buchen",
      items: {
        aesthetik: {
          title: "Ästhetische Zahnheilkunde",
          subtitle: "Ihr schönstes Lächeln in besten Händen",
          description: "Ein strahlendes Lächeln ist mehr als nur schön – es ist Ausdruck von Gesundheit, Selbstbewusstsein und Lebensfreude. Wir verbinden moderne Zahnmedizin mit einem besonderen Blick für Ästhetik.",
          services: [
            "Professionelle Zahnaufhellung (Bleaching)",
            "Veneers und Keramik-Inlays",
            "Zahnfarbene Füllungen und Restaurationen",
            "Zahnform- und Zahnstellungskorrekturen"
          ]
        },
        prophylaxe: {
          title: "Professionelle Zahnreinigung (PZR) in Dachau",
          subtitle: "Für ein dauerhaft gesundes Lächeln",
          description: "Ein strahlendes Lächeln beginnt mit der richtigen Vorsorge. In unserer Praxis in Dachau setzen wir auf ein individuelles Prophylaxe-Konzept, das weit über das häusliche Zähneputzen hinausgeht. Selbst bei gründlichster Pflege erreichen Sie schwer zugängliche Stellen oft nicht – hier setzt unsere Professionelle Zahnreinigung (PZR) an. Unsere erfahrenen Prophylaxe-Assistentinnen entfernen hartnäckige Beläge, Zahnstein und unschöne Verfärbungen (z. B. durch Kaffee, Tee oder Tabak) sanft und effektiv.",
          services: [
            "Vorbeugung: Schutz vor Karies und Parodontitis",
            "Langlebigkeit: Ihr Zahnersatz und Ihre Implantate halten deutlich länger",
            "Wellness für die Zähne: Eine schmerzfreie Behandlung in entspannter Atmosphäre",
            "Spürbar glattere Zähne und ein frischer Atem"
          ]
        },
        implantologie: {
          title: "Zahnimplantate in Dachau",
          subtitle: "Fester Halt und natürliche Ästhetik",
          description: "Ein Zahnverlust beeinträchtigt oft nicht nur das Kauen, sondern auch das Selbstbewusstsein. Mit modernster Implantologie in Dachau geben wir Ihnen die Lebensqualität zurück, die Sie verdienen. Zahnimplantate sind die modernste und natürlichste Form des Zahnersatzes: Sie fungieren als künstliche Zahnwurzel und bieten die Basis für Kronen, Brücken oder stabilen Halt für Prothesen. Dr. Muresan-Richter verfügt über langjährige Erfahrung in der Implantologie.",
          services: [
            "Natürliches Gefühl: Kein Unterschied zu Ihren echten Zähnen beim Essen oder Sprechen",
            "Knochenerhalt: Implantate verhindern den Rückgang des Kieferknochens",
            "Schonung der Nachbarzähne: Anders als bei Brücken müssen gesunde Zähne nicht beschliffen werden",
            "Von der Einzelzahnlösung bis hin zu komplexen Versorgungen"
          ]
        },
        kiefergelenk: {
          title: "Kiefergelenksprobleme",
          subtitle: "Hilfe bei Kieferknacken und Schmerzen",
          description: "Haben Sie Kieferknacken, Schmerzen beim Kauen oder Verspannungen im Nackenbereich? Häufig sind diese Symptome auf Stress, Fehlhaltungen oder Zahnfehlstellungen zurückzuführen.",
          services: [
            "Diagnose von Kiefergelenksstörungen",
            "Individuell angepasste Knirschschienen",
            "Therapie bei Bruxismus",
            "Ganzheitliche Behandlungsansätze"
          ]
        },
        vollkeramik: {
          title: "Vollkeramik",
          subtitle: "Natürliche Ästhetik und höchste Qualität",
          description: "Vollkeramische Versorgungen bieten eine natürliche Ästhetik und höchste Biokompatibilität für anspruchsvolle Zahnrestaurationen.",
          services: [
            "Keramikkronen und -brücken",
            "Inlays und Onlays",
            "Metallfreie Restaurationen",
            "Höchste Präzision und Langlebigkeit"
          ]
        },
        parodontitis: {
          title: "Parodontitisbehandlung",
          subtitle: "Für ein gesundes Zahnfleisch",
          description: "Parodontitis ist eine chronische Entzündung des Zahnhalteapparates, die unbehandelt zu Zahnlockerung oder sogar Zahnverlust führen kann.",
          services: [
            "Gründliche Diagnose",
            "Sanfte Reinigung unterhalb des Zahnfleischrandes",
            "Individuelle Nachsorge",
            "Regelmäßige Kontrollen"
          ]
        },
        veneers: {
          title: "Veneers",
          subtitle: "Hauchdünne Keramikschalen für perfekte Zähne",
          description: "Veneers sind hauchdünne Keramikschalen, die auf die Frontzähne geklebt werden und kleine Makel perfekt kaschieren.",
          services: [
            "Minimalinvasive Präparation",
            "Natürliche Farbgestaltung",
            "Langlebige Ergebnisse",
            "Individuelle Formgebung"
          ]
        }
      }
    },
    // Team Section
    team: {
      subtitle: "Lernen Sie uns kennen",
      title: "Unser Team",
      jobPosting: "Werde Teil unseres Teams!",
      toJobPosting: "Zur Stellenanzeige",
      roles: {
        dentist: "Zahnarzt",
        assistantDoctor: "Assistenzärztin",
        zmv: "ZMV/Stuhlassistenz",
        chairAssistant: "Stuhlassistenz",
        prophylaxis: "Prophylaxe"
      }
    },
    // Job Modal
    job: {
      title: "Zahnmedizinische Fachangestellte (W/M/D)",
      subtitle: "Werde Teil unseres Teams!",
      tasksTitle: "Kernaufgaben einer ZMA/ZFA:",
      tasks: [
        "Behandlungsassistenz: Vorbereitung des Behandlungszimmers, Anreichen von Instrumenten, Absaugen, Füllungsmaterialien anmischen.",
        "Hygienemanagement: Reinigung, Desinfektion und Sterilisation von Instrumenten und Geräten.",
        "Patientenbetreuung: Empfang, Terminvereinbarung, Vor- und Nachbereitung der Patienten.",
        "Röntgen: Anfertigen von Röntgenaufnahmen (bei entsprechender Qualifikation).",
        "Verwaltung: Dokumentation von Behandlungsabläufen, Abrechnungswesen."
      ],
      requirementsTitle: "Anforderungsprofil - Das bringst du mit:",
      requirements: [
        "Abgeschlossene Ausbildung zur Zahnmedizinischen Fachangestellten (ZFA / ZMA)",
        "Freundliches Auftreten und Empathie im Umgang mit Patienten",
        "Sorgfältige und strukturierte Arbeitsweise",
        "Teamfähigkeit, Zuverlässigkeit und Organisationstalent",
        "Freude am Umgang mit Menschen",
        "Idealerweise Kenntnisse in Praxissoftware",
        "Gute Deutschkenntnisse – weitere Sprachen von Vorteil"
      ],
      benefitsTitle: "Das bieten wir dir:",
      benefits: [
        "Ein wertschätzendes und kollegiales Team",
        "Moderne Praxis mit hochwertiger Ausstattung",
        "Attraktive und leistungsgerechte Vergütung",
        "Flexible Arbeitszeiten / gute Work-Life-Balance",
        "Fort- und Weiterbildungsmöglichkeiten",
        "Langfristige Perspektive in einer sicheren Branche"
      ],
      interested: "Interessiert? Dann freuen wir uns auf Ihre Bewerbung!",
      applyNow: "Jetzt bewerben"
    },
    // Reviews Section
    reviews: {
      subtitle: "Das sagen unsere Patienten",
      title: "Google Bewertungen",
      onGoogle: "auf Google",
      yourOpinion: "Ihre Meinung ist uns wichtig!",
      satisfied: "Waren Sie mit Ihrem Besuch bei uns zufrieden? Wir freuen uns über Ihre Bewertung auf Google!",
      rateNow: "Jetzt bewerten",
      viewOnMaps: "Auf Google Maps ansehen",
      followUs: "Folge uns",
      fbNews: "Aktuelle Neuigkeiten und Einblicke aus unserer Praxis",
      followFb: "Folge uns auf Facebook",
      igStories: "Bilder und Stories aus unserem Praxisalltag",
      followIg: "Folge uns auf Instagram"
    },
    // Location Section
    location: {
      subtitle: "So finden Sie uns",
      title: "Anfahrt & Kontakt",
      contactData: "Kontaktdaten",
      address: "Adresse",
      phone: "Telefon",
      openingHours: "Öffnungszeiten",
      directions: "Anreise",
      byCar: "Mit dem Auto:",
      byCarText: "Parkmöglichkeiten direkt vor dem Haus an der Straße.",
      publicTransport: "Öffentliche Verkehrsmittel:",
      publicTransportText: "S-Bahn Dachau, dann Busverbindung 744 bis Würmstraße.",
      saveContact: "Kontakt speichern"
    },
    // Footer
    footer: {
      tagline: "Zahnarztpraxis Muresan-Richter – Ihr Partner für Zahngesundheit in Dachau. Erreichbar für Patienten aus Dachau, Karlsfeld, München, Markt Indersdorf und Umgebung.",
      bookAppointment: "Termin buchen",
      quickLinks: "Schnellzugriff",
      legal: "Rechtliches",
      imprint: "Impressum",
      privacy: "Datenschutz",
      copyright: "Alle Rechte vorbehalten."
    },
    // Cookie Consent
    cookies: {
      title: "Cookie-Einstellungen",
      text: "Wir verwenden Cookies, um Ihnen die bestmögliche Erfahrung auf unserer Website zu bieten. Essentielle Cookies sind für die Grundfunktionen erforderlich. Weitere Informationen finden Sie in unserer",
      privacyLink: "Datenschutzerklärung",
      acceptAll: "Alle akzeptieren",
      acceptEssential: "Nur essenzielle"
    }
  },
  
  en: {
    // Navigation
    nav: {
      contact: "Contact",
      treatments: "Treatments",
      team: "Team",
      directions: "Directions",
      jobs: "Jobs",
      call: "Call",
      bookNow: "Book Appointment"
    },
    // Hero Section
    hero: {
      welcome: "Welcome to Your Dentist in Dachau",
      title1: "",
      title2: "Your Smile in Best Hands",
      description: "At the Muresan-Richter dental practice in Dachau, an experienced team awaits you, dedicated to caring for your smile with individual consultation, gentle treatment methods, and state-of-the-art dentistry.",
      services: "Our Services",
      saveContact: "Save Contact",
      address: "Address",
      phone: "Phone",
      openingHours: "Opening Hours"
    },
    // About Section
    about: {
      title: "Dental Practice in Dachau – Your Dental Health is Our Passion",
      text1: "We offer you a wide range of services – from professional teeth cleaning (PTC) and prophylaxis to aesthetic dentistry, implants, and dental prosthetics.",
      text2: "Our bright, friendly practice rooms and relaxed atmosphere ensure that you feel comfortable from the very beginning.",
      callBtn: "Call",
      bookBtn: "Book Appointment"
    },
    // Treatments Section
    treatments: {
      subtitle: "Our Services in Dachau",
      title: "Treatment Areas",
      hint: "Click for more details",
      learnMore: "Learn more",
      ourServices: "Our Services:",
      bookAppointment: "Book Appointment",
      items: {
        aesthetik: {
          title: "Aesthetic Dentistry",
          subtitle: "Your most beautiful smile in the best hands",
          description: "A radiant smile is more than just beautiful – it is an expression of health, self-confidence, and joy of life. We combine modern dentistry with a special eye for aesthetics.",
          services: [
            "Professional teeth whitening (bleaching)",
            "Veneers and ceramic inlays",
            "Tooth-colored fillings and restorations",
            "Tooth shape and position corrections"
          ]
        },
        prophylaxe: {
          title: "Prophylaxis (PTC)",
          subtitle: "For your radiant and healthy smile",
          description: "Your own teeth are always better than any dental prosthesis. One of the most important building blocks of tooth preservation is prophylaxis.",
          services: [
            "Gentle removal of plaque and discoloration",
            "Regular examination by the dentist",
            "Control of your oral health",
            "Valuable tips for daily care at home"
          ]
        },
        implantologie: {
          title: "Implantology",
          subtitle: "Natural tooth replacement for better quality of life",
          description: "In today's world, no one has to accept missing teeth. Functional and aesthetic limitations due to tooth gaps significantly reduce quality of life.",
          services: [
            "Individual implant planning",
            "Minimally invasive procedures",
            "High-quality implant systems",
            "Comprehensive aftercare"
          ]
        },
        kiefergelenk: {
          title: "TMJ Problems",
          subtitle: "Help with jaw clicking and pain",
          description: "Do you have jaw clicking, pain when chewing, or tension in the neck area? These symptoms are often due to stress, poor posture, or tooth misalignment.",
          services: [
            "Diagnosis of TMJ disorders",
            "Individually fitted bite splints",
            "Bruxism therapy",
            "Holistic treatment approaches"
          ]
        },
        vollkeramik: {
          title: "All-Ceramic",
          subtitle: "Natural aesthetics and highest quality",
          description: "All-ceramic restorations offer natural aesthetics and highest biocompatibility for demanding dental restorations.",
          services: [
            "Ceramic crowns and bridges",
            "Inlays and onlays",
            "Metal-free restorations",
            "Highest precision and durability"
          ]
        },
        parodontitis: {
          title: "Periodontal Treatment",
          subtitle: "For healthy gums",
          description: "Periodontitis is a chronic inflammation of the tooth-supporting structures that, if left untreated, can lead to tooth loosening or even tooth loss.",
          services: [
            "Thorough diagnosis",
            "Gentle cleaning below the gum line",
            "Individual aftercare",
            "Regular check-ups"
          ]
        },
        veneers: {
          title: "Veneers",
          subtitle: "Wafer-thin ceramic shells for perfect teeth",
          description: "Veneers are wafer-thin ceramic shells that are bonded to the front teeth and perfectly conceal small imperfections.",
          services: [
            "Minimally invasive preparation",
            "Natural color design",
            "Long-lasting results",
            "Individual shaping"
          ]
        }
      }
    },
    // Team Section
    team: {
      subtitle: "Get to know us",
      title: "Our Team",
      jobPosting: "Become part of our team!",
      toJobPosting: "To job posting",
      roles: {
        dentist: "Dentist",
        assistantDoctor: "Assistant Dentist",
        zmv: "Dental Office Manager",
        chairAssistant: "Dental Assistant",
        prophylaxis: "Prophylaxis"
      }
    },
    // Job Modal
    job: {
      title: "Dental Assistant (F/M/D)",
      subtitle: "Become part of our team!",
      tasksTitle: "Core tasks of a dental assistant:",
      tasks: [
        "Treatment assistance: Preparing the treatment room, handing instruments, suctioning, mixing filling materials.",
        "Hygiene management: Cleaning, disinfection, and sterilization of instruments and equipment.",
        "Patient care: Reception, appointment scheduling, patient preparation and follow-up.",
        "X-rays: Taking X-ray images (with appropriate qualification).",
        "Administration: Documentation of treatment procedures, billing."
      ],
      requirementsTitle: "Requirements - What you bring:",
      requirements: [
        "Completed training as a dental assistant",
        "Friendly demeanor and empathy in dealing with patients",
        "Careful and structured way of working",
        "Team skills, reliability, and organizational talent",
        "Enjoyment of working with people",
        "Ideally knowledge of practice software",
        "Good German language skills – other languages an advantage"
      ],
      benefitsTitle: "What we offer you:",
      benefits: [
        "An appreciative and collegial team",
        "Modern practice with high-quality equipment",
        "Attractive and performance-based compensation",
        "Flexible working hours / good work-life balance",
        "Further education and training opportunities",
        "Long-term perspective in a secure industry"
      ],
      interested: "Interested? We look forward to receiving your application!",
      applyNow: "Apply Now"
    },
    // Reviews Section
    reviews: {
      subtitle: "What our patients say",
      title: "Google Reviews",
      onGoogle: "on Google",
      yourOpinion: "Your opinion matters to us!",
      satisfied: "Were you satisfied with your visit? We appreciate your review on Google!",
      rateNow: "Rate Now",
      viewOnMaps: "View on Google Maps",
      followUs: "Follow us",
      fbNews: "Current news and insights from our practice",
      followFb: "Follow us on Facebook",
      igStories: "Pictures and stories from our daily practice",
      followIg: "Follow us on Instagram"
    },
    // Location Section
    location: {
      subtitle: "How to find us",
      title: "Directions & Contact",
      contactData: "Contact Information",
      address: "Address",
      phone: "Phone",
      openingHours: "Opening Hours",
      directions: "Getting Here",
      byCar: "By car:",
      byCarText: "Parking available directly in front of the building on the street.",
      publicTransport: "Public transport:",
      publicTransportText: "S-Bahn Dachau, dann Busverbindung 744 bis Würmstraße.",
      saveContact: "Save Contact"
    },
    // Footer
    footer: {
      tagline: "Modern dentistry in Dachau – individual, gentle, and with heart.",
      bookAppointment: "Book Appointment",
      quickLinks: "Quick Links",
      legal: "Legal",
      imprint: "Imprint",
      privacy: "Privacy Policy",
      copyright: "All rights reserved."
    },
    // Cookie Consent
    cookies: {
      title: "Cookie Settings",
      text: "We use cookies to provide you with the best possible experience on our website. Essential cookies are required for basic functions. For more information, please see our",
      privacyLink: "Privacy Policy",
      acceptAll: "Accept All",
      acceptEssential: "Essential Only"
    }
  },
  
  hu: {
    // Navigation
    nav: {
      contact: "Kapcsolat",
      treatments: "Kezelések",
      team: "Csapat",
      directions: "Megközelítés",
      jobs: "Állások",
      call: "Hívás",
      bookNow: "Időpontfoglalás"
    },
    // Hero Section
    hero: {
      welcome: "Üdvözöljük fogorvosánál Dachauban",
      title1: "",
      title2: "Mosolya a legjobb kezekben",
      description: "A dachaui Muresan-Richter fogorvosi rendelőben tapasztalt csapat várja Önt, akik egyéni tanácsadással, kíméletes kezelési módszerekkel és korszerű fogászattal gondoskodnak mosolyáról.",
      services: "Szolgáltatásaink",
      saveContact: "Kapcsolat mentése",
      address: "Cím",
      phone: "Telefon",
      openingHours: "Nyitvatartás"
    },
    // About Section
    about: {
      title: "Fogorvosi rendelő Dachauban – Az Ön fogegészsége a mi szenvedélyünk",
      text1: "Széles szolgáltatási spektrumot kínálunk – a professzionális fogászati tisztítástól és megelőzéstől az esztétikai fogászaton át az implantátumokig és fogpótlásig.",
      text2: "Világos, barátságos rendelőink és a nyugodt légkör biztosítja, hogy a kezdetektől jól érezze magát.",
      callBtn: "Hívás",
      bookBtn: "Időpontfoglalás"
    },
    // Treatments Section
    treatments: {
      subtitle: "Szolgáltatásaink Dachauban",
      title: "Kezelési területek",
      hint: "Kattintson a részletekért",
      learnMore: "Részletek",
      ourServices: "Szolgáltatásaink:",
      bookAppointment: "Időpontfoglalás",
      items: {
        aesthetik: {
          title: "Esztétikai fogászat",
          subtitle: "A legszebb mosolya a legjobb kezekben",
          description: "A ragyogó mosoly több mint szép – az egészség, az önbizalom és az életöröm kifejezése. A modern fogászatot különleges esztétikai szemlélettel ötvözzük.",
          services: [
            "Professzionális fogfehérítés",
            "Héjak és kerámia betétek",
            "Fogszínű tömések és restaurációk",
            "Fogforma és fogállás korrekciók"
          ]
        },
        prophylaxe: {
          title: "Profilaxis (PZR)",
          subtitle: "A ragyogó és egészséges mosolyért",
          description: "A saját fogak mindig jobbak bármilyen fogpótlásnál. A fogmegőrzés egyik legfontosabb építőköve a megelőzés.",
          services: [
            "Foglepedék és elszíneződés kíméletes eltávolítása",
            "Rendszeres fogorvosi vizsgálat",
            "Szájegészség ellenőrzése",
            "Értékes tippek az otthoni ápoláshoz"
          ]
        },
        implantologie: {
          title: "Implantológia",
          subtitle: "Természetes fogpótlás a jobb életminőségért",
          description: "Ma már senkinek sem kell beletörődnie a hiányzó fogakba. A foghézagok okozta funkcionális és esztétikai korlátozások jelentősen rontják az életminőséget.",
          services: [
            "Egyéni implantátum tervezés",
            "Minimálisan invazív beavatkozások",
            "Kiváló minőségű implantátum rendszerek",
            "Átfogó utógondozás"
          ]
        },
        kiefergelenk: {
          title: "Állkapocs problémák",
          subtitle: "Segítség állkapocs kattogásnál és fájdalomnál",
          description: "Állkapocs kattogás, rágás közbeni fájdalom vagy nyaki feszültség? Ezek a tünetek gyakran stresszre, rossz testtartásra vagy fogászati rendellenességekre vezethetők vissza.",
          services: [
            "Állkapocs rendellenességek diagnózisa",
            "Egyénileg illesztett fogcsikorgatás elleni sínek",
            "Bruxizmus terápia",
            "Holisztikus kezelési megközelítések"
          ]
        },
        vollkeramik: {
          title: "Teljes kerámia",
          subtitle: "Természetes esztétika és legmagasabb minőség",
          description: "A teljes kerámia restaurációk természetes esztétikát és legmagasabb biokompatibilitást kínálnak az igényes fogászati restaurációkhoz.",
          services: [
            "Kerámia koronák és hidak",
            "Betétek és fedések",
            "Fémmentes restaurációk",
            "Legmagasabb precizitás és tartósság"
          ]
        },
        parodontitis: {
          title: "Parodontitis kezelés",
          subtitle: "Az egészséges ínyért",
          description: "A parodontitis a fogágy krónikus gyulladása, amely kezeletlen esetben fog lazuláshoz vagy akár fogvesztéshez vezethet.",
          services: [
            "Alapos diagnózis",
            "Kíméletes tisztítás az ínyszél alatt",
            "Egyéni utógondozás",
            "Rendszeres ellenőrzések"
          ]
        },
        veneers: {
          title: "Héjak",
          subtitle: "Vékony kerámia héjak a tökéletes fogakért",
          description: "A héjak vékony kerámia burkolatok, amelyeket a fronális fogakra ragasztanak, és tökéletesen elfedik a kisebb hibákat.",
          services: [
            "Minimálisan invazív előkészítés",
            "Természetes színezés",
            "Hosszú távú eredmények",
            "Egyéni formázás"
          ]
        }
      }
    },
    // Team Section
    team: {
      subtitle: "Ismerjen meg minket",
      title: "Csapatunk",
      jobPosting: "Legyen a csapatunk tagja!",
      toJobPosting: "Az álláshoz",
      roles: {
        dentist: "Fogorvos",
        assistantDoctor: "Asszisztens orvos",
        zmv: "Rendelővezető",
        chairAssistant: "Fogászati asszisztens",
        prophylaxis: "Profilaxis"
      }
    },
    // Job Modal
    job: {
      title: "Fogászati asszisztens (N/F/D)",
      subtitle: "Legyen a csapatunk tagja!",
      tasksTitle: "Fogászati asszisztens alapfeladatai:",
      tasks: [
        "Kezelési asszisztencia: Kezelőhelyiség előkészítése, műszerek átadása, szívás, tömőanyagok keverése.",
        "Higiénia menedzsment: Műszerek és berendezések tisztítása, fertőtlenítése és sterilizálása.",
        "Betegellátás: Recepció, időpontegyeztetés, betegek előkészítése és utógondozása.",
        "Röntgen: Röntgenfelvételek készítése (megfelelő képesítéssel).",
        "Adminisztráció: Kezelési folyamatok dokumentálása, számlázás."
      ],
      requirementsTitle: "Követelmények - Amit hoz:",
      requirements: [
        "Befejezett fogászati asszisztens képzés",
        "Barátságos fellépés és empátia a betegekkel való kapcsolatban",
        "Gondos és strukturált munkamódszer",
        "Csapatmunka, megbízhatóság és szervezőkészség",
        "Örömmel dolgozik emberekkel",
        "Lehetőleg rendelői szoftver ismeretek",
        "Jó német nyelvtudás – további nyelvek előny"
      ],
      benefitsTitle: "Amit kínálunk:",
      benefits: [
        "Megbecsülő és kollegiális csapat",
        "Modern rendelő kiváló felszereléssel",
        "Vonzó és teljesítményalapú díjazás",
        "Rugalmas munkaidő / jó munka-magánélet egyensúly",
        "Továbbképzési lehetőségek",
        "Hosszú távú perspektíva egy biztos ágazatban"
      ],
      interested: "Érdeklődik? Várjuk jelentkezését!",
      applyNow: "Jelentkezés"
    },
    // Reviews Section
    reviews: {
      subtitle: "Mit mondanak a pácienseink",
      title: "Google értékelések",
      onGoogle: "a Google-on",
      yourOpinion: "Az Ön véleménye fontos számunkra!",
      satisfied: "Elégedett volt a látogatásával? Örülünk a Google értékelésének!",
      rateNow: "Értékelés",
      viewOnMaps: "Megtekintés a Google Térképen",
      followUs: "Kövessen minket",
      fbNews: "Aktuális hírek és betekintés a rendelőnkbe",
      followFb: "Kövessen a Facebookon",
      igStories: "Képek és történetek a rendelői mindennapokból",
      followIg: "Kövessen az Instagramon"
    },
    // Location Section
    location: {
      subtitle: "Hogyan talál meg minket",
      title: "Megközelítés és kapcsolat",
      contactData: "Kapcsolati adatok",
      address: "Cím",
      phone: "Telefon",
      openingHours: "Nyitvatartás",
      directions: "Megközelítés",
      byCar: "Autóval:",
      byCarText: "Parkolási lehetőség közvetlenül az épület előtt az utcán.",
      publicTransport: "Tömegközlekedéssel:",
      publicTransportText: "S-Bahn Dachau, dann 744-es busz a Würmstraße-ig.",
      saveContact: "Kapcsolat mentése"
    },
    // Footer
    footer: {
      tagline: "Modern fogászat Dachauban – egyéni, kíméletes és szívvel.",
      bookAppointment: "Időpontfoglalás",
      quickLinks: "Gyors linkek",
      legal: "Jogi információk",
      imprint: "Impresszum",
      privacy: "Adatvédelem",
      copyright: "Minden jog fenntartva."
    },
    // Cookie Consent
    cookies: {
      title: "Cookie beállítások",
      text: "Cookie-kat használunk a lehető legjobb élmény biztosításához weboldalunkon. Az alapvető cookie-k szükségesek az alapfunkciókhoz. További információkért lásd a",
      privacyLink: "Adatvédelmi nyilatkozatot",
      acceptAll: "Összes elfogadása",
      acceptEssential: "Csak az alapvetőek"
    }
  }
};
